import { useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import { ProjectDetailsContext } from '@/screens/Project.Main/Context';
import type { AppLoadedPayload } from '@/store/interfaces';
import { useCallback, useContext } from 'react';


export const useInvalidateFilesQuery = () => {
  const details = useContext(ProjectDetailsContext);
  const queryClient = useQueryClient();
  const baseInvalidateFilesQueries = useInvalidateFilesQueries();


  const invalidateProjectFiles = useCallback(() => {
    if (details) {
      return queryClient.invalidateQueries({
        queryKey: [
          `get:projects/files`,
          details.query.data.project.id,
          details.query.data.project.parentId,
        ],
      });
    }
  }, [details, queryClient]);

  const { entity, object } = useSelector((state: AppLoadedPayload) => state.workspace.group);

  const invalidateWorkspaceFiles = useCallback(() => {
    if (entity && object) {
      return queryClient.invalidateQueries({
        queryKey: [
          `get:workspaces/objects`,
          entity.id,
          object.id,
        ],
      });
    }
  }, [entity, object, queryClient]);

  return useCallback(() => {
    invalidateProjectFiles();
    invalidateWorkspaceFiles();
    baseInvalidateFilesQueries();
  }, [baseInvalidateFilesQueries, invalidateProjectFiles, invalidateWorkspaceFiles]);
};